<template>
  <div>
    <IBranchHeader></IBranchHeader>
    <slot />
  </div>
</template>

<script>
import IBranchHeader from '@/shared/widget/ibranch/header'
export default {
  name: 'App',
  components: {
    IBranchHeader
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/desktop/template/IBranch.vue